import type { PortfolioBatchResult, PortfolioBatchSpec } from "../types/portfolioRuns";

interface RunPortfolioBatchResponse {
  ok: boolean;
  batch?: PortfolioBatchResult;
  error?: string;
}

function handleError(response: Response, payload: { error?: string }, fallback: string): never {
  const message = payload?.error ?? `${fallback} (status ${response.status})`;
  throw new Error(message);
}

export async function runPortfolioBatch(spec: PortfolioBatchSpec): Promise<PortfolioBatchResult> {
  const response = await fetch("/api/portfolio/runs", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(spec),
  });

  const payload = (await response.json()) as RunPortfolioBatchResponse;

  if (!response.ok || payload.ok === false || !payload.batch) {
    handleError(response, payload, "Failed to run portfolio batch");
  }

  return payload.batch;
}
